import { NativeStackHeaderProps, Stack } from 'expo-router';
import {
  getFlowNameForAnalytics,
  TabaPayEntryFlowType,
} from 'features/moveMoney/screens/dcf/tabapay/helpers/TabaPay.helpers';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { IllustrationKeyType } from 'shared/components/vxl/Illustration/Illustration';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';
import theme from 'shared/styles/theme';

interface VerifyCardScreenProps {
  title: string;
  contentText: string;
  buttonLabel: string;
  onContinue: () => void;
  onBackClick: () => void;
  illustrationKey: IllustrationKeyType;
  isLoading?: boolean;
  tabaPayEntryFlowType?: TabaPayEntryFlowType;
}

const VerifyCardScreen = ({
  title,
  contentText,
  buttonLabel,
  onContinue,
  illustrationKey,
  onBackClick,
  isLoading,
  tabaPayEntryFlowType,
}: VerifyCardScreenProps) => {
  const flowName = getFlowNameForAnalytics(tabaPayEntryFlowType!);
  const analyticsCommonAttributes = {
    subcategory: flowName,
    flow_name: flowName,
  };

  useViewDidFocusScreenAnalyticsEvent({
    key: 'verify-card-screen',
    customAttributes: analyticsCommonAttributes,
  });

  const nextButtonOnPressEvent = usePressableAnalytics({
    analyticsId: 'verifyCardClicked',
    customAttributes: analyticsCommonAttributes,
  });

  return (
    <>
      <Stack.Screen
        options={{
          headerShown: true,
          title: '',
          headerBackVisible: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} primaryOnPress={onBackClick} />
          ),
        }}
      />
      <View style={styles.container}>
        <ActionScreen
          visual={illustrationKey}
          titleText={title}
          titleTextStyle="extra-large"
          bodyContent={
            <BodyBaseText numberOfLines={0}>{contentText}</BodyBaseText>
          }
          primaryButton={{
            isLoading: isLoading,
            label: buttonLabel,
            onPress: () => {
              nextButtonOnPressEvent();
              onContinue();
            },
          }}
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default VerifyCardScreen;
